/**
 * Generates the next available key for a new entity following the pattern `new_[entity]`,
 * `new_[entity]_2`, `new_[entity]_3`, etc.
 *
 * @param existingKeys - The current keys to check against for conflicts.
 * @param entity - The entity name to use in the key (e.g. `'context'`, `'input'`, `'output'`).
 * @returns A unique key of the form `new_[entity]` or `new_[entity]_N`.
 */
export function getNextNewKey( existingKeys: string[], entity: string ): string {
  const baseKey = `new_${ entity }`;

  const pattern = new RegExp( `^new_${ entity }(_(\\d+))?$` );

  let highestNumber = 0;

  existingKeys.forEach( ( key ) => {
    const match = key.match( pattern );

    if ( match ) {
      const num = match[2] ? parseInt( match[2] ) : 0;

      if ( num > highestNumber ) {
        highestNumber = num;
      }
    }
  } );

  return highestNumber === 0 && !existingKeys.includes( baseKey )
    ? baseKey
    : `${ baseKey }_${ highestNumber + 1 }`;
}
